export default "__VITE_ASSET__t_qt3CzZ__"